import React from "react";
import { Header50 } from "./components/Header50";
import { PersonalIntroduction } from "./components/PersonalIntroduction";
import { InnovativeApproach } from "./components/InnovativeApproach";
import { DualCaseStudies } from "./components/DualCaseStudies";
import { Contact14 } from "../components/shared/Contact14";
import { Footer } from "../components/shared/Footer";

export default function Page() {
  return (
    <div>
      <Header50 />
      <PersonalIntroduction />
      <InnovativeApproach />
      <DualCaseStudies />
      <Contact14 />
      <Footer />
    </div>
  );
}
